module.exports = __webpack_public_path__ + "static/media/icon-adherence-issue-neutral.859ccdbd.svg";